import React from "react";

// Titles are stored like this to allow easy handling of the tag without worrying about isolating it from parentheses
const tags = [
  {tag: "A1", label: "A1 Medical Transport"},
  {tag: "ACE", label: "Ace Ride Transportation"},
  {tag: "ADV", label: "Advantage Transport"},
  {tag: "AHSC", label: "Asian Health and Service Center"},
  {tag: "ALB", label: "Exceed Enterprises"},
  {tag: "ALI", label: "Ali Transportation"},
  {tag: "APL", label: "A Plus Medical Transport "},
  {tag: "BCAB", label: "Broadway Cab"},
  {tag: "CAD", label: "Canby Adult Center"},
  {tag: "CEN", label: "Centro Cultural"},
  {tag: "CIT", label: "City Ride"},
  {tag: "CTO", label: "ComTrans/Ambulance"},
  {tag: "EAS", label: "Easy Ride"},
  {tag: "EBE", label: "Ebenezer Medical Transport"},
  {tag: "ECC", label: "Friends of Estacada Community Center"},
  {tag: "EDC", label: "Edwards Center"},
  {tag: "EGA", label: "Evergreen Ambulance "},
  {tag: "EZW", label: "EZ Way Transit"},
  {tag: "FLT", label: "Flat Transportation"},
  {tag: "GAT", label: "Gateway Transportation Services"},
  {tag: "GCC", label: "Gladstone Community Center"},
  {tag: "GIG", label: "GiGi Transport"},
  {tag: "HAR", label: "Harar Medical Transportation"},
  {tag: "HLA", label: "Helena Transit"},
  {tag: "HSC", label: "Hoodland Senior Center"},
  {tag: "ICM", label: "I Care Medical Transportation"},
  {tag: "INW", label: "Impact NW"},
  {tag: "JBM", label: "JB Medical Transportation"},
  {tag: "KAR", label: "Kare Medical Transit"},
  {tag: "KAS", label: "Kassa Transportation"},
  {tag: "KCR", label: "RC King City (Red) "},
  {tag: "LEA", label: "Leah's Medical Transportation"},
  {tag: "LIS", label: "Lisha Transport"},
  {tag: "LOAC", label: "Lake Oswego Adult Community Center"},
  {tag: "MAC", label: "Molalla Adult Center (Foothills CC)"},
  {tag: "MCC", label: "Milwaukie Center"},
  {tag: "MDX", label: "Medex Transit"},
  {tag: "MER", label: "Mercy Med Transit"},
  {tag: "MFS", label: "MFS Project Linkage"},
  {tag: "MIK", label: "Mikes Transportation"},
  {tag: "MJT", label: "Mojos Transportation"},
  {tag: "MM", label: "M and M Med Transit"},
  {tag: "MMG", label: "MMG Medical Transportation"},
  {tag: "MPL", label: "Michael's Place"},
  {tag: "MWA", label: "Metro West Ambulance"},
  {tag: "NHC", label: "Neighborhood House"},
  {tag: "NWPDX", label: "NWPDX"},
  {tag: "ODA", label: "ODAA Medical Transportation"},
  {tag: "OLY", label: "Olympia Medical Transportation"},
  {tag: "PCC", label: "Pioneer Community Center"},
  {tag: "PEP", label: "Providence Elderplace"},
  {tag: "PRI", label: "Prime Transportation"},
  {tag: "PYC", label: "PDX Yellow Cab"},
  {tag: "RAD", label: "Radio Cab"},
  {tag: "RAM", label: "Raammis Transit"},
  {tag: "RCB", label: "RC Beaverton"},
  {tag: "RCEC", label: "RC East county (Eco), "},
  {tag: "RCFG", label: "RC Forest Grove (WaCo) "},
  {tag: "RCH", label: "RC Hillsboro"},
  {tag: "RCI", label: "Ride Connection"},
  {tag: "RCM", label: "RC Midco"},
  {tag: "RCT", label: "RC Tualatin"},
  {tag: "REL", label: "Reliable Medical Transportation"},
  {tag: "RIP", label: "Rip City Transit"},
  {tag: "RTC", label: "Ride Together"},
  {tag: "SID", label: "Sidra Transportation"},
  {tag: "SOV", label: "Sovereign Medical Transportation"},
  {tag: "SSC", label: "Sandy Senior Center"},
  {tag: "SUP", label: "Supreme Medical Transportation"},
  {tag: "TEH", label: "Tehama Transportation"},
  {tag: "TSC", label: "TSC Medical Transportation"},
  {tag: "ULP", label: "Urban League of Portland"},
  {tag: "UNI", label: "United Care Medical Transport"},
  {tag: "VAN", label: "Vanguard Care"},
  {tag: "WEL", label: "Wellness Transportation"},
  {tag: "WST", label: "Wapato Shores"},
  {tag: "WVT", label: "Willamette Valley Transport"},
  {tag: "YAR", label: "Yared Medical Transportation"},
  {tag: "ZOO", label: "Zoom Transportation"}
];


const TagDropdown = ({selectedTag, setSelectedTag}) => {
  
  const handleTagChange = (event) => {
    setSelectedTag(event.target.value);
    console.log(event.target.value);
  };

  return (
    <div>
      <select value={selectedTag} onChange={handleTagChange}>
        <option value="">No tag filter</option>

        {tags.map(({tag, label}, index) => (
          <option key={index} value={tag}>
            ({tag}) - {label}
          </option>
        ))}
      </select>
    </div>
  )

};

export default TagDropdown;